export const newInvoice = 'newInvoice';
export const descriptionTemplates = "descriptionTemplates";
export const accountingSystemSettings = 'accountingSystemSettings';
export const myobAccountRightAuthForm = 'myobAccountRightAuthForm';
